<template>
  <!-- Content -->
  <div
    class="flex h-full w-full items-center justify-center gap-6"
    :class="props.orientation === 'vertical' ? 'flex-col' : 'flex-row'">
    <div
      v-if="props.icon"
      class="relative z-10"
      :class="props.orientation === 'vertical' ? 'p-4' : 'p-3'">
      <slot name="icon">
        <component
          :is="props.icon"
          :size="props.orientation === 'vertical' ? 30 : 18"
          :class="iconColor" />

        <div
          class="absolute left-0 top-0 h-full w-full rounded-full opacity-10"
          :class="bgColor"></div>
      </slot>
    </div>

    <div
      v-if="props.title || props.text"
      :class="props.orientation === 'vertical' ? 'text-center' : ''">
      <slot name="content">
        <h3 v-if="props.title" class="mb-2">{{ props.title }}</h3>
        <p v-if="props.text" class="max-w-xl">{{ props.text }}</p>
      </slot>
    </div>

    <div
      v-if="(showDocsBtn || showCreateBtn) && props.orientation === 'vertical'"
      class="grid grid-cols-2">
      <SmButton
        v-if="showDocsBtn"
        type="primary"
        :class="{ 'col-span-2': !showCreateBtn }"
        outline
        @click="emit('showDocs')">
        {{ props.docsLabel ?? i18n.t('readDocs') }}
      </SmButton>
      <SmButton
        v-if="showCreateBtn"
        type="primary"
        :class="{ 'col-span-2': !showDocsBtn }"
        @click="emit('create')">
        {{ props.createLabel ?? i18n.t('create') }}
        <slot name="create-btn"></slot>
      </SmButton>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Component } from 'lucide-vue-next'
  import { PropType } from 'vue'
  import { useI18n } from 'vue-i18n'

  const i18n = useI18n()
  const emit = defineEmits(['create', 'showDocs'])

  const props = defineProps({
    icon: {
      type: Boolean as PropType<Component>,
      required: false,
      default: () => false,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    text: {
      type: String,
      required: false,
      default: '',
    },
    createLabel: {
      type: String,
      required: false,
      default: '',
    },
    docsLabel: {
      type: String,
      required: false,
      default: '',
    },
    showDocsBtn: {
      type: Boolean,
      default: true,
    },
    showCreateBtn: {
      type: Boolean,
      default: true,
    },
    orientation: {
      type: String,
      default: 'vertical',
    },
    color: {
      type: String,
      default: 'primary',
    },
  })

  const iconColor = computed(() => {
    if (props.color === 'error') return 'text-red'
    if (props.color === 'warning') return 'text-orange'
    return 'text-primary'
  })

  const bgColor = computed(() => {
    if (props.color === 'error') return 'bg-red'
    if (props.color === 'warning') return 'bg-orange'
    return 'bg-primary'
  })
</script>
